import React, { useState, useEffect } from "react";

import styles from "./kamaThemeCard.module.css";

const colors = [
  ["#3CDFEA", "#0B9099"],
  ["#EA7EA5", "#FF5391"],
  ["#9D52CB", "#CB528C"],
  ["#6D2885", "#290934"],
  ["#C20CBB", "#E03372"],
  ["#DC0038", "#780000"],
];

export default function KamaThemeCard({ theme, index, onClick }) {
  const color = colors[index % colors.length];
  const [show, setShow] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShow(true);
    }, 100 * index);
  }, [index]);

  const handleClick = () => {
    onClick && onClick(theme);
  };

  return (
    <button className="touchable-opacity" type="button" onClick={handleClick}>
      <div
        className={`${styles.card} ${show ? styles.show : ""}`}
        style={{
          background: `linear-gradient(90deg, ${color[0]}, ${color[1]})`,
        }}
      >
        <div className="flex items-center">
          <div className="text-left flex-1">
            <h2 className="text-lg font-bold">{theme.title}</h2>
            <p className="text-xs leading-3">{theme.description}</p>
          </div>
          <div className="flex flex-col items-center ms-3">
            <img
              className="w-5 object-contain max-w-[unset] mb-1"
              src={require("../../../assets/icons/lovecard.png")}
              alt="card"
            />
            <span className="text-xs">
              {theme.acquired || 0}/{theme.total}
            </span>
          </div>
        </div>
      </div>
    </button>
  );
}
